export const sliderConfig = (slidesToShow = 7, slidesToScroll = 5, dots = false, numOfSlidesOnMobile = 2) => {
    return {
        infinite: false,
        speed: 500,
        slidesToShow: slidesToShow,
        slidesToScroll: slidesToScroll,
        initialSlide: 0,
        dots: dots,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 5,
                    slidesToScroll: 3,
                    infinite: true,
                    dots: false
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 2,
                    initialSlide: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: numOfSlidesOnMobile,
                    slidesToScroll: numOfSlidesOnMobile
                }
            }
        ]
    };

}